import { useNotificationIntegration } from '@/hooks/useNotificationIntegration'
import { TELEGRAM_NOTIFICATION_BOT_REFETCH_EVENT } from '@/helpers/notificationIntegration'

export { TELEGRAM_NOTIFICATION_BOT_REFETCH_EVENT }

/** Thin wrapper around shared notification-integration hook (telegram). */
export const useTelegramNotificationBotIntegration = (
  userId: string | number | null | undefined,
  userRole: string | null | undefined,
) => {
  const result = useNotificationIntegration('telegram', userId, userRole)

  return {
    status: result.status,
    integrationId: result.integrationId,
    botUsername: result.displayHandle,
    necessarily: result.necessarily,
  }
}
